// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".src-components-accounts-Accounts__container--1LVPr{padding-top:1em}\n", "",{"version":3,"sources":["C:/Gitlab-Runner/builds/josiD6fY/0/developers/comtax-admin/src/components/accounts/Accounts.scss"],"names":[],"mappings":"AAAA,oDACI,eAAgB","file":"Accounts.scss","sourcesContent":[".container {\r\n    padding-top: 1em;\r\n}\r\n\r\n"]}]);
// Exports
exports.locals = {
	"container": "src-components-accounts-Accounts__container--1LVPr"
};
module.exports = exports;
